// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qrQc","footer":"styles_footer__1P1pI","passCodeTooltip":"styles_passCodeTooltip__3EM53"};